import { useEffect, useMemo, useState, useCallback } from 'react'
import '../../index.css'
import SubjectContainer from './SubjectHistoryContainer'
import GrileService from '../../../../services/grile-service'

import HistoryGridSkeleton from '../HistoryGridSkeleton'
import { NavLink } from 'react-router-dom'
import Button from '../../../../components/Button'

const SubjectsHistory = ({ subjects, isLoading }) => {
  const [renderCount, setRenderCount] = useState(20)
  const [books, setBooks] = useState([])

  const handleGetSubjectCorrectCount = useCallback(subject => {
    return subject['grile'].filter(
      grila => grila.correct_answer === grila.choice,
    ).length
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent =
        window.scrollY / (document.body.offsetHeight - window.innerHeight)
      if (scrollPercent > 0.8) {
        setRenderCount(current => current + 20)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    async function fetchBooks() {
      const books = await GrileService.getAllBooks()
      setBooks(books)
    }
    fetchBooks()
  }, [])

  const mappedSubjects = useMemo(() => {
    return subjects?.slice(0, renderCount).map((subiect, index) => {
      return (
        <SubjectContainer
          subjectName={subiect?.subject_name}
          key={`subject-${index}`}
          subiectId={subiect.subject_id}
          grile={subiect.grile}
          timestamp={subiect.timestamp}
          solvingTime={subiect.solving_time}
          correctNrGrile={handleGetSubjectCorrectCount(subiect)}
          books={books}
        />
      )
    })
  }, [subjects, handleGetSubjectCorrectCount, renderCount, books])

  return (
    <div className="sm:rounded sm:p-5 border border-brd-primary overflow-hidden overflow-x-hidden mb-[20px] mt-[10px] relative w-full !min-h-[75svh] bg-secondary-background rounded p-[10px]">
      <div>
        {!isLoading ? (
          subjects?.length === 0 ? (
            <div className="flex mt-16 flex-col text-over-primary-background justify-center items-center gap-3">
              <span>Nu ai rezolvat nicio simulare</span>{' '}
              <NavLink to="/subiect">
                <Button className="bg-btn-primary">Către simulări</Button>
              </NavLink>
            </div>
          ) : (
            mappedSubjects
          )
        ) : (
          Array(10)
            .fill(0)
            .map((_, index) => (
              <HistoryGridSkeleton key={`subject-skeleton-${index}`} />
            ))
        )}
      </div>
    </div>
  )
}
export default SubjectsHistory
